var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mapHistoryDateHint"},[_c('svgicon',{attrs:{"icon":"history","width":"32","height":"32"}}),_vm._v("\n  "+_vm._s(_vm._f("defaultDay")(_vm.date))+",\n  "+_vm._s(_vm._f("defaultDate")(_vm.date))+"\n    "+_vm._s(_vm._f("defaultTime")(_vm.date))+"\n")],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-324cd3a4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MapHistoryDateHint.vue
// module id = null
// module chunks = 